import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// Base API URL from environment variables
const apiUrl = process.env.REACT_APP_API_URL;



// Helper function to handle the async thunk lifecycle
const handleAsyncThunk = (state) => {
  state.loading = true;
  state.error = null;
};

// Thunk: Fetch all Agents
export const fetchAgents = createAsyncThunk(
  "agents/fetchAgents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/GetAgents/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Failed to fetch Agents");
    }
  }
);

// Thunk: Fetch Agent Details by ID
export const fetchAgentDetails = createAsyncThunk(
  "agents/fetchAgentDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/GetAgents/${id}/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || "Failed to fetch agent details");
    }
  }
);



// Initial state
const initialState = {
  agents: [], // List of all agents
  agentDetails: null, // Details of a single agent fetched by ID
  loading: false,
  error: null,
  successMessage: null, // Message to display after successful actions
};

// Slice: Agents
const agentsSlice = createSlice({
  name: "agents",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Agents
      .addCase(fetchAgents.pending, (state) => {
        handleAsyncThunk(state); // Handling loading state
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload;
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Agent Details by ID
      .addCase(fetchAgentDetails.pending, (state) => {
        handleAsyncThunk(state); // Handling loading state
      })
      .addCase(fetchAgentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.agentDetails = action.payload;
      })
      .addCase(fetchAgentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      
  },
});



// Export Actions
export const { clearMessages } = agentsSlice.actions;

// Export Reducer
export const allagentsReducer = agentsSlice.reducer;

export default allagentsReducer;
